import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Workbench from "@/pages/Workbench";
import Offers from "@/pages/Offers";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Users from "@/pages/admin/Users";
import Trash from "@/pages/admin/Trash";
import SystemPage from "@/pages/admin/SystemPage";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminErrors from "@/pages/admin/AdminErrors";
import AdminLearningRules from "@/pages/admin/AdminLearningRules";
import EmailSettingsPage from "@/pages/EmailSettingsPage";
import LogOfferte from "@/pages/reports/LogOfferte";
import InsegnaPage from "@/pages/InsegnaPage";
import AdminCompanyTemplatesPage from "@/pages/AdminCompanyTemplatesPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Offers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/offerte"
            element={<Navigate to="/" replace />}
          />
          <Route
            path="/workbench"
            element={
              <ProtectedRoute>
                <Layout>
                  <Workbench />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/trash"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Layout>
                  <Trash />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/system"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Layout>
                  <SystemPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/audit"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Layout>
                  <AdminAudit />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/errors"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Layout>
                  <AdminErrors />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/learning-rules"
            element={
              <ProtectedRoute roles={["super_admin", "titolare", "commercial"]}>
                <Layout>
                  <AdminLearningRules />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/email"
            element={
              <ProtectedRoute>
                <Layout>
                  <EmailSettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/log-offerte"
            element={
              <ProtectedRoute roles={["super_admin", "titolare"]}>
                <Layout>
                  <LogOfferte />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/insegna"
            element={
              <ProtectedRoute roles={["super_admin", "titolare"]}>
                <Layout>
                  <InsegnaPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/templates"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Layout>
                  <AdminCompanyTemplatesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster
          position="bottom-right"
          theme="dark"
          duration={3000}
          closeButton
          toastOptions={{
            style: {
              background: "#18181B",
              color: "#FFFFFF",
              border: "1px solid #27272A",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 500,
              padding: "10px 14px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
